export default {
  home: '首页',
  exhibitionCenters: '会展中心',
  hostVenue: '举办展馆',
  venueArea: '场馆面积',
  squareMeter: '平方米',
  viewMap: '查看地图',
  countryRegion: '国家地区',
  contactPhone: '联系电话',
  officialWebsite: '官网地址',
  venueDetails: '展馆详情',
  exhibitionSchedule: '展会排期',
  all: '全部',
  currentYear: '当年',
  nextYear: '明年',
  otherInformation: '其他信息',
  floorPlan: '平面图',
  relatedExhibitions: '相关展会',
  more: '更多',
  daysUntilExhibition: '距离开展还有',
  days: '天',
  exhibitionInProgress: '开展中...',
  timeUpdating: '时间更新中......'
}
